import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {SynapiPredicate} from "../../../models/Synapi/SynapiPredicate";
import {SynapiService} from "../../../services/synapi.service";
import {SynapiFilters} from "../../../models/Synapi/SynapiFilters";
import {CommonModule} from "@angular/common";
import {FindPipe} from "../../../pipes/find.pipe";
import {CustomToggleComponent} from "../inputs/custom-toggle/custom-toggle.component";
import {TreeSearchPipe} from "../../../pipes/tree-search.pipe";
import {NgxSmartModalComponent} from "ngx-smart-modal";
import {ArraySortPipe} from "../../../pipes/sort.pipe";

@Component({
  selector: 'synapi-filters',
  templateUrl: './synapi-filters.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FindPipe,
    CustomToggleComponent,
    TreeSearchPipe,
    ArraySortPipe
  ],
  styleUrls: ['./synapi-filters.component.scss']
})

export class SynapiFiltersComponent implements OnInit {
    public dateHelper: any;
    @Input() predicate: SynapiPredicate;
    @Input() selectionId: string;
    @Input() selectedOnly: boolean = false;
    @Input() modal: NgxSmartModalComponent;
    @Output() predicateChange = new EventEmitter<SynapiPredicate>();
    @Output() geolocationActiveChange = new EventEmitter<boolean>();
    public filterSelected: SynapiFilters|null;
    public filtersTree: SynapiFilters;
    constructor() {

    }

    async ngOnInit() {
      const filtersPredicate = new SynapiPredicate();
      filtersPredicate.id = this.selectionId;

    }

    addFilter(filter: SynapiFilters){
      if(filter){
        if(!this.predicate.ids.find((i)=>i === filter.id)){
          this.predicate.ids.unshift(filter.id);
          this.predicateChange.next(this.predicate);
        }
      }
    };

    removeFilter(filter: SynapiFilters){
        const index = this.predicate.ids.findIndex((i)=>i === filter.id);
        if(index !== -1){
          this.predicate.ids.splice(index,1);
          this.predicateChange.next(this.predicate);
        }
    };

    toggleFilter(isActive:boolean,filter:SynapiFilters|string){
      if(typeof filter === 'string'){
        const id = filter;
        filter = new SynapiFilters();
        filter.id = id;
      }
      if(isActive){
        this.addFilter(filter);
      } else{
        this.removeFilter(filter);
      }
    }

    setDates(min: Date,max: Date){
        this.predicate.datemin = min.toISOString().split('T')[0];
        this.predicate.datemax = max.toISOString().split('T')[0];
        this.predicateChange.next(this.predicate);
    }

    static getNextDayOfWeek(date: Date, dayOfWeek: number) {
        var resultDate = new Date(date.getTime());
        resultDate.setDate(date.getDate() + (7 + dayOfWeek - date.getDay()) % 7);
        return resultDate;
    };

  onGeolocationActiveChange($event: boolean) {
    this.geolocationActiveChange.emit($event);
  }
}
